import { render, staticRenderFns } from "./RestrictedCommonArticleItem.vue?vue&type=template&id=d49cc902&"
import script from "./RestrictedCommonArticleItem.vue?vue&type=script&lang=js&"
export * from "./RestrictedCommonArticleItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/daum/program/jenkins/workspace/cafe-web/cafe-web-production/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d49cc902')) {
      api.createRecord('d49cc902', component.options)
    } else {
      api.reload('d49cc902', component.options)
    }
    module.hot.accept("./RestrictedCommonArticleItem.vue?vue&type=template&id=d49cc902&", function () {
      api.rerender('d49cc902', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/bbs-list/bottom/components/RestrictedCommonArticleItem.vue"
export default component.exports